import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const hypervisorFeatures = [
  { pct: '%30', label: 'Performans İyileşmesi' },
  { pct: '%50', label: 'Maliyet Tasarrufu' },
  { pct: '%100', label: 'Veri Dayanıklılığı' },
];

const storageFeatures = [
  {
    icon: 'ri-server-line',
    title: 'Hypervisor Entegreli vSAN',
    desc: 'VergeFS, VergeOS\'a doğrudan entegre edilmiş bir vSAN\'dır. Kaynaklar için rekabet eden ayrı bir yazılım paketi değildir. Bu entegrasyon hiper yöneticiyi VergeFS\'nin tüm işlevlerinden haberdar kılar.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Mevcut SAN Depolamasını Destekler',
    desc: 'FC tabanlı depolama dizileri, ek donanım yatırımı gerektirmeksizin doğrudan VergeOS ortamına katkıda bulunabilir. Yazılım tanımlı depolama çözümleri yalnızca "depolama düğümü" olarak yeniden kullanılabilir.',
  },
  {
    icon: 'ri-hdd-line',
    title: 'Sunucu Depolamasını Sanallaştırır',
    desc: 'VergeOS, ağ bağlantı kümeleme için ethernet portlarına doğrudan bağlanan vSAN protokolünü kullanır. NVMe, SAS, SATA Flash Depolama ve Hard Disk Sürücüleri desteklenir.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Eşsiz Veri Dayanıklılığı',
    desc: 'VergeOS, sürücü arızası, sunucu arızası, yanlışlıkla silme veya veri bozulmasından bağımsız olarak tam veri dayanıklılığı ve koruma sağlar.',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Hypervisor Destekli Tekilleştirme',
    desc: 'Tekilleştirme hiper yönetici veya ağ için küçük bir fayda sağladığından, VergeFS ağ genelinde yedekli segmentleri tespit eder ve bunları ağ veya diğer düğümler tarafından işlenmeye göndermez.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Depolama Yenilemelerini Ortadan Kaldırır',
    desc: 'Mevcut sunucularınızı ve depolama alanınızı değiştirmenizi gerektiren zorluk, ek donanım maliyeti gerektirmeksizin mevcut donanım yatırımınızdan yararlanarak çözülür.',
  },
];

const faqList = [
  {
    q: 'vSAN nedir?',
    a: 'Sanal Depolama Ağı (vSAN), birden fazla ağa bağlı sunucudan fiziksel depolamayı tek bir sanal birim olarak sunan bir depolama sanallaştırma teknolojisidir. Bu birim merkezi bir konsoldan yönetilir ve kontrolün sanal makinenin üzerinde olması nedeniyle, kurumsal ve eski sanallaştırma ortamlarının kapasitesi de dahil olmak üzere birden fazla fiziksel sunucunun depolama kaynaklarını yönetme ve tahsis etme konusunda daha fazla esneklik sağlar.',
  },
  {
    q: 'VergeFS\'yi eski vSAN teknolojilerinden farklı kılan nedir?',
    a: 'VergeFS, hiper yöneticiye doğrudan entegre edilmiştir. Bu, hiper yönetici farkındalığı sayesinde ağ ve depolama kararlarını koordineli şekilde optimize ederken, geleneksel vSAN çözümleri ayrı katmanlar olarak çalışır.',
  },
  {
    q: 'VergeFS mevcut SAN depolamayı destekler mi?',
    a: 'Evet. FC tabanlı depolama dizileri doğrudan VergeOS ortamına katkıda bulunabilir ve yazılım tanımlı depolama çözümleri yalnızca depolama düğümleri olarak yeniden kullanılabilir.',
  },
  {
    q: 'VergeFS ne kadar maliyet tasarrufu sağlar?',
    a: 'Müşteriler genellikle donanım konsolidasyonu, azaltılmış lisanslama ve işletimsel verimlilik sayesinde mevcut depolama yaklaşımlarına kıyasla %50\'ye kadar maliyet tasarrufu bildirmektedir.',
  },
  {
    q: 'VergeFS veri dayanıklılığını nasıl sağlar?',
    a: 'VergeFS, birden fazla sürücü ve sunucu arızasından gerçek zamanlı kurtarma sağlayarak tam aktif-aktif yüksek erişilebilirlik sunar. Veri yedeklemeleri, anlık görüntüler ve çoğaltma tümü hiper yönetici düzeyinde yerel olarak entegre edilmiştir.',
  },
];

const vergefsFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'vSAN nedir?', acceptedAnswer: { '@type': 'Answer', text: 'Sanal Depolama Ağı (vSAN), birden fazla ağa bağlı sunucudan fiziksel depolamayı tek bir sanal birim olarak sunan bir depolama sanallaştırma teknolojisidir.' } },
    { '@type': 'Question', name: "VergeFS'yi eski vSAN teknolojilerinden farklı kılan nedir?", acceptedAnswer: { '@type': 'Answer', text: "VergeFS, hiper yöneticiye doğrudan entegre edilmiştir. Bu, hiper yönetici farkındalığı sayesinde ağ ve depolama kararlarını koordineli şekilde optimize eder." } },
    { '@type': 'Question', name: 'VergeFS mevcut SAN depolamayı destekler mi?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. FC tabanlı depolama dizileri doğrudan VergeOS ortamına katkıda bulunabilir ve yazılım tanımlı depolama çözümleri yalnızca depolama düğümleri olarak yeniden kullanılabilir.' } },
    { '@type': 'Question', name: 'VergeFS ne kadar maliyet tasarrufu sağlar?', acceptedAnswer: { '@type': 'Answer', text: "Müşteriler genellikle %50'ye kadar maliyet tasarrufu bildirmektedir." } },
    { '@type': 'Question', name: 'VergeFS veri dayanıklılığını nasıl sağlar?', acceptedAnswer: { '@type': 'Answer', text: 'VergeFS, birden fazla sürücü ve sunucu arızasından gerçek zamanlı kurtarma sağlayarak tam aktif-aktif yüksek erişilebilirlik sunar.' } },
  ],
};

const vergefsAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeFS',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeFS, VergeOS\'a entegre hypervisor-aware vSAN depolama çözümüdür. %30 performans iyileşmesi, %50 maliyet tasarrufu, %100 veri dayanıklılığı.',
  url: `${SITE_URL}/vergefs`,
};

export default function VergeFSPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="VergeFS | Hypervisor Entegreli vSAN Depolama | VergeOS"
        description="VergeFS, VergeOS'a entegre hypervisor-aware vSAN depolama çözümüdür. %30 performans iyileşmesi, %50 maliyet tasarrufu, tam veri dayanıklılığı ile kurumsal depolama."
        keywords="VergeFS, vSAN, yazılım tanımlı depolama, NAS, SAN, hypervisor depolama, VergeOS depolama"
        canonicalPath="/vergefs"
        jsonLd={[vergefsAppJsonLd, vergefsFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Mimari
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              VergeFS — <span className="text-[#e8600a]">Daha İyi Bir vSAN</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 font-medium">Kurumsal Sınıf Performans, Ölçeklenebilirlik ve Esneklik</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/architecture" className="bg-[#e8600a] hover:bg-[#cc5208] text-white font-semibold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap">
                Mimari Genel Bakış
              </a>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-gray-50 border-b border-gray-200 py-10">
          <div className="max-w-4xl mx-auto px-6">
            <div className="grid grid-cols-3 gap-6 text-center">
              {hypervisorFeatures.map((f) => (
                <div key={f.label}>
                  <p className="text-3xl font-extrabold text-[#e8600a] mb-1">{f.pct}</p>
                  <p className="text-sm text-gray-600">{f.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hypervisor Aware */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Entegre vSAN'a Sahip Hypervisor</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  VergeFS vSAN, VergeOS içine doğrudan entegre edilmiştir; kaynaklar için rekabet eden ayrı bir yazılım paketi değildir. Bu entegrasyon, hiper yöneticiyi VergeFS'nin tüm işlevlerinin farkında kılar ve yükü düşürerek verimliliği artırır.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-sm text-gray-700">
                    <i className="ri-check-line text-[#e8600a] text-lg"></i>
                    %30 Performans İyileşmesi
                  </li>
                  <li className="flex items-center gap-3 text-sm text-gray-700">
                    <i className="ri-check-line text-[#e8600a] text-lg"></i>
                    %50 Maliyet Tasarrufu
                  </li>
                  <li className="flex items-center gap-3 text-sm text-gray-700">
                    <i className="ri-check-line text-[#e8600a] text-lg"></i>
                    %100 Veri Dayanıklılığı
                  </li>
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/b2c541dfeccda7cb2942a58f0625ae57.jpg"
                  alt="VergeFS Depolama Altyapısı"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Feature Grid */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">VergeFS Yetenekleri</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">
                VergeFS'in depolama yönetimine yaklaşımınızı nasıl dönüştürdüğünü keşfedin
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {storageFeatures.map((f) => (
                <div key={f.title} className="bg-white rounded-lg border border-gray-100 p-6">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{f.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Data Resiliency */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=high%20availability%20data%20resiliency%20diagram%20showing%20multiple%20server%20nodes%20with%20redundant%20storage%20connections%20and%20failover%20paths%20highlighted%20in%20orange%2C%20technical%20infrastructure%20resilience%20visualization%20with%20dark%20background%20professional%20data%20center%20design&width=580&height=380&seq=vergefs_resil1&orientation=landscape"
                  alt="VergeFS Veri Dayanıklılığı"
                  className="w-full h-full object-top"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Eşsiz Veri Dayanıklılığı</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  En önemlisi, VergeOS tam veri dayanıklılığı ve koruma sağlar; sürücü arızası, sunucu arızası, yanlışlıkla silme veya veri bozulmasından bağımsız olarak. VergeOS ortamına entegrasyonu, veri sürekliliğini garanti ederken performansı ve esnekliği artırır.
                </p>
                <ul className="space-y-3">
                  {['Gerçek zamanlı çoklu sürücü/sunucu arızasından kurtarma', 'Anlık görüntü tabanlı nokta-içi kurtarma', 'Siteler arası replikasyon desteği', 'Uygulama tutarlı yedekleme'].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-shield-check-line text-[#e8600a] text-lg shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">vSAN ve VergeFS Hakkında SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                  >
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0">
                      <i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                    </span>
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
